function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";
import PolizaRenewalForm from "./components/PolizaRenewalForm";
import { colorStatus } from "./helper/polizaRenewalHelper";
import "./polizaRenewal.scss";

var EditPolizaRenewal = function EditPolizaRenewal(props) {
  var polizaRenewal = props.polizaRenewal,
      token = props.token,
      conditions = props.conditions,
      condition_update_reasons = props.condition_update_reasons,
      client_rejects_renewal_reasons = props.client_rejects_renewal_reasons,
      company_rejects_renewal_reasons = props.company_rejects_renewal_reasons;

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      editingPolizaRenewal = _React$useState2[0],
      setPolizaRenewal = _React$useState2[1];

  React.useEffect(function () {
    if (!editingPolizaRenewal) setPolizaRenewal(polizaRenewal);
  }, [polizaRenewal]);

  if (editingPolizaRenewal) {
    return /*#__PURE__*/React.createElement("div", {
      className: "container-fluid"
    }, /*#__PURE__*/React.createElement("div", {
      className: "page-header"
    }, /*#__PURE__*/React.createElement("h4", null, /*#__PURE__*/React.createElement("b", null, "Editar Renovaci\xF3n de poliza ", editingPolizaRenewal.poliza.code)), /*#__PURE__*/React.createElement("h5", null, colorStatus(editingPolizaRenewal.aasm_state), editingPolizaRenewal.status_name)), /*#__PURE__*/React.createElement(PolizaRenewalForm, {
      polizaRenewal: editingPolizaRenewal,
      token: token,
      conditions: conditions,
      conditionUpdateReasons: condition_update_reasons,
      clientRejectsRenewalReasons: client_rejects_renewal_reasons,
      companyRejectsRenewalReasons: company_rejects_renewal_reasons,
      onChange: function onChange(aPolizaRenewal) {
        setPolizaRenewal(aPolizaRenewal);
      }
    }));
  } else {
    return null;
  }
};

export default EditPolizaRenewal;